module.exports = __webpack_public_path__ + "assets/img/NPC003.88c59fac.png";